import mixpanel from 'mixpanel-browser';

const source = 'dashboard:reviews';

export default {
    trackRatingClick(ratingData) {
        mixpanel.track(`${source}:rating_clicked`, {
            Rating: ratingData
        });
    }
};
